import React  from 'react';
import { LoadingButton } from '@mui/lab';

const ButtonCustom = ({
    text = "Guardar",
    variant = "contained",
    icon,
    iconPosition = "start",
    onClick,
    color,
    loading,
    style,
    children,
    disabled = false
}) => {

    let propsButton = {
        text,
        variant,
        onClick,
        color,
        loading,
        style,
        disabled
    };

    if(color === undefined) {
        delete propsButton['color']
    }

    if (icon) {
        if (iconPosition === "start") {
            propsButton["startIcon"] = icon;
        } else {
            propsButton["endIcon"] = icon;
        }
    }

    if (loading === true || loading === false) {
        propsButton["loadingPosition"] = iconPosition;
    }

    return (
        <LoadingButton
            {...propsButton}
        >
            {children || text}
        </LoadingButton>
    )
}

export default ButtonCustom
